import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import MonitoringIndex from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/monitoring'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'monitoring_wrapper',
          component: MonitoringIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
